import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import history from "../store/history";
import user from './user';
import consent from './consent';

const appReducer = combineReducers({
  router: connectRouter(history),
  user,
  consent,
});

const reducers = (state, action) => {
    //console.log("Action =========> ", action);
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'LOGOUT_SUCCESS') {
        state = undefined;
    }

    return appReducer(state, action)
};

export const persistedReducers = [user];

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js